import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const getClientParamsSchema = (t: TFunction) => Yup.object().shape({
    emailUAC: Yup.string()
        .nullable()
        .notRequired()
        .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, {
            message: t("common:form.invalidEmailFormat"),
            excludeEmptyString: true,
        }),
    logo: Yup.mixed()
        .nullable()
        .notRequired()
        .test("fileFormat", t("common:form.invalidFormat"), (value) => {
            if (!value) return true;

            if (value instanceof File)
                return ['image/jpg', 'image/jpeg', 'image/png'].includes(value.type);
            
            return typeof value === 'string';
        }),
    campaignSurveysSendingTime: Yup.string()
        .nullable()
        .notRequired()
        .matches(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, t("common:form.hourInvalidFormat")),
    sentimentMinimumValue: Yup.number()
        .nullable()
        .notRequired()
        .min(1, t("common:form.valueMustBeGreatherOrEqualThan", { num: 1 })),
    sentimentMaximumValue: Yup.number()
        .nullable()
        .notRequired()
        .test("is-greater", t("common:form.valueMustBeGreatherThanMinimum"), function (value) {
            const { sentimentMinimumValue } = this.parent;
            
            if (value === undefined || value === null || sentimentMinimumValue === null)
                return true;
            return value > sentimentMinimumValue;
        }),
    alertMinimumValue: Yup.number()
        .nullable()
        .notRequired()
        .min(1, t("common:form.valueMustBeGreatherOrEqualThan", { num: 1 })),
    alertMaximumValue: Yup.number()
        .nullable()
        .notRequired()
        .test("is-greater", t("common:form.valueMustBeGreatherThanMinimum"), function (value) {
            const { alertMinimumValue } = this.parent;
            
            if (value === undefined || value === null || alertMinimumValue === null)
                return true;
            return value > alertMinimumValue;
        }),
    commentAlertMinimumValue: Yup.number()
        .nullable()
        .notRequired()
        .min(1, t("common:form.valueMustBeGreatherOrEqualThan", { num: 1 })),
    commentAlertMaximumValue: Yup.number()
        .nullable()
        .notRequired()
        .test("is-greater-or-equal", t("common:form.valueMustBeGreatherOrEqualThanMinimum"), function (value) {
            const { commentAlertMinimumValue } = this.parent;
            
            if (value === undefined || value === null || commentAlertMinimumValue === null)
                return true;
            return value >= commentAlertMinimumValue;
        })
});
